/**
 * Helpers de roles del sistema (deben coincidir con `Roles` del backend).
 *
 * Antes existía un rol "paraguas" `Autorizador`; se eliminó. Ahora un usuario
 * es autorizador simplemente por tener el rol específico de algún nivel
 * (`AutorizadorNivel1` / `AutorizadorNivel2`) o el rol `Contabilidad` (autoriza
 * el subtipo Invoice). NO incluye `MesaDeControl`. Espejo de `Roles.Autorizadores`
 * del backend.
 */
export const ROLES_AUTORIZADOR = ["AutorizadorNivel1", "AutorizadorNivel2", "Contabilidad"] as const;

/** True si el usuario tiene el rol de autorizador de algún nivel. */
export function tieneRolAutorizador(roles: ReadonlyArray<string>): boolean {
  return roles.some((r) => (ROLES_AUTORIZADOR as readonly string[]).includes(r));
}
